import billLogApi from '@/api/billLog/billLogApi'

export default {
	name: 'bill-log-email',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			billLog: { phList: {} },
			email: '',
			phListChosen: []
		};
	},
	computed: {

	},
	watch: {},
	created() {

	},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			this.billLog.phList = await billLogApi.getBillLogMonths();
		},
		// 西元年月轉換為民國年月
		ADToRepublicEra(year, month) {
			if (year && month) {
				return year - 1911 + '年 ' + month + '月';
			}
		},
		// 寄送email
		async applySubmit() {
			let valid = await this.$validator.validate();
			if (valid) {
				let randomCodeEncode = await billLogApi.billLogEMailCheck();
				// res 返回 randomCode
				if (randomCodeEncode) {
					this.$router.push({
						name: 'bill-log-email-check',
						params: {
							toEmail: this.email,
							phListChosen: this.phListChosen,
							randomCode: randomCodeEncode
						}
					}); // 帶著所選月份與randomCode導往下一頁
				}
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/billLog/billLogEMail.js